import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PlanoContaMatrizAppRoutingModule } from "./plano-contas-matriz.app-routing.module";

@NgModule({
    imports: [
        CommonModule,
        PlanoContaMatrizAppRoutingModule
    ]
})
export class PlanoContaMatrizAppModule { }
